import { useEffect } from "react";
import { Provider } from 'react-redux';
import { store } from 'app/store';
import { LanguageProvider } from "context/LanguageContext";
import { CartProvider } from "context/CartContext";
import AppRoutes from "app/router/AppRouter";
import { HomeProvider } from 'context/HomeContext';
import { getCurrentClientConfig } from "config/clientConfig";

export default function App() {
  useEffect(() => {
    const clientConfig = getCurrentClientConfig();
    document.title = clientConfig.brandName;
    document.documentElement.style.setProperty(
      "--tenant-primary-color",
      clientConfig.primaryColor
    );
    document.documentElement.style.setProperty(
      "--tenant-secondary-color",
      clientConfig.secondaryColor
    );
    document.documentElement.dataset.defaultGridView = clientConfig.defaultGridView
      ? "grid"
      : "list";
  }, []);

  return (
    <Provider store={store}>
      <LanguageProvider>
      <HomeProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
      </HomeProvider>
      </LanguageProvider>
    </Provider>
  );
}
